(function(){
  var canvas = document.getElementById('sb-avatar-canvas');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  var size = 36;
  canvas.width = size; canvas.height = size;

  /* gradient background */
  var grad = ctx.createLinearGradient(0, 0, size, size);
  grad.addColorStop(0, '#1d4ed8');
  grad.addColorStop(1, '#2563eb');
  ctx.beginPath();
  ctx.arc(size/2, size/2, size/2, 0, Math.PI*2);
  ctx.fillStyle = grad;
  ctx.fill();

  /* initials */
  ctx.fillStyle = '#ffffff';
  ctx.font = 'bold 18px Mukta, sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText('रा', size/2, size/2 + 1);
})();

/* ── Navbar avatar canvas ── */
(function(){
  var nb = document.getElementById('nb-avatar-canvas');
  if (!nb) return;
  var ctx = nb.getContext('2d');
  var s = 32;
  nb.width = s; nb.height = s;
  var g = ctx.createLinearGradient(0,0,s,s);
  g.addColorStop(0,'#1d4ed8'); g.addColorStop(1,'#3b82f6');
  ctx.beginPath(); ctx.arc(s/2,s/2,s/2,0,Math.PI*2);
  ctx.fillStyle=g; ctx.fill();
  ctx.fillStyle='#fff'; ctx.font='bold 13px Mukta,sans-serif';
  ctx.textAlign='center'; ctx.textBaseline='middle';
  ctx.fillText('रा', s/2, s/2+1);
})();

/* ── Sidebar styling ── */
$(function(){

  /* Logout link color */
  $('#logout-link').css('color','rgba(252,165,165,.85)');
  $('#logout-link .nav-icon').css({
    'color':'rgba(248,113,113,.75)',
    'background':'rgba(239,68,68,.14)'
  });

  /* Chevron rotate on treeview open/close */
  $('.nav-sidebar').on('click', '>.nav-item>.nav-link', function(){
    var $item = $(this).closest('.nav-item');
    setTimeout(function(){
      var open = $item.hasClass('menu-open');
      $item.find('>.nav-link .nav-arrow i')
        .removeClass('fa-chevron-left fa-chevron-down')
        .addClass(open ? 'fa-chevron-down' : 'fa-chevron-left');
    }, 10);
  });

  /* Restore correct initial chevron state */
  $('.nav-sidebar .nav-item.menu-open>.nav-link .nav-arrow i')
    .removeClass('fa-chevron-left').addClass('fa-chevron-down');
});